import * as React from 'react';
import PowerBiViewReport from './PowerBiViewReport';
import PowerBiDashboard from './PowerBiDashboard';

export interface IPowerBiViewControllerProps {
  reportId: string;
  type: string;
}

export default class PowerBiViewController extends React.Component<
  IPowerBiViewControllerProps
> {
  public render() {
    return (
      <div>
        {this.props.type == 'report' && (
          <PowerBiViewReport reportId={this.props.reportId} />
        )}
        {this.props.type == 'dashboard' && (
          <PowerBiDashboard dashboardId={this.props.reportId} />
        )}
      </div>
    );
  }
}
